import { Component, OnInit, ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from '../../data-entity-view/data-entity-view.component';
import { IssueDateDataEntity } from 'src/app/models/data-entities/issue-date-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-issue-date-data-entity-view',
    templateUrl: './issue-date-data-entity-view.component.html',
    styleUrls: ['./issue-date-data-entity-view.component.css'],
    standalone: false
})
export class IssueDateDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, context);
  }
  issueDateEntity: IssueDateDataEntity;

  ngOnInit() {
    this.issueDateEntity = <IssueDateDataEntity>this.entity;
  }
  getSafeDisplayDate(value: string): string {
  if (!value) return '';

  const date = new Date(value);

  return isNaN(date.getTime())
    ? ''
    : date.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric'
      });
}
}
